import { useQuery } from '@tanstack/react-query'
import { alertsApi, type AlertHistoryQuery } from '../../services/admin/alertsApi'

export const useAlertHistoryQuery = (query: AlertHistoryQuery) =>
  useQuery({
    queryKey: ['admin', 'alerts', 'history', query],
    queryFn: () => alertsApi.history(query),
    placeholderData: (prev) => prev,
  })
